<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="prm-list" v-loading="pageloading">
    <main-head>
      <template v-slot:pageName>
        {{ $t("page.projectSearch") }}
      </template>
    </main-head>
    <main-content>
      <template v-slot:contentArea>
        <div class="form">
          <el-form ref="form" :model="form">
            <el-row :gutter="20" style="margin: 25px 0 25px">
              <el-col :span="24">
                <div style="font-size:20px">
                  <span>
                    <img slot="reference" src="../../assets/公文包.jpg" style="transform:scale(1.5,1.5)"></span>
                  {{ $t('page.prmDetail.contentTitle') }}
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <!-- <el-col :span="5">
                <el-form-item :label="$t('page.prmList.registration')" />
                <el-input v-model="form.registrationNo" :placeholder="$t('message.registration')" />
              </el-col> -->
              <el-col :span="6">
                <el-form-item :label="$t('page.prmList.registration')">
                  <el-input v-model="form.registrationNo" :placeholder="$t('message.registrationNo')" maxlength="256" @blur="getList(form.registrationNo,'registrationNo')" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('page.prmList.projectName')">
                  <el-input v-model="form.projectName" :placeholder="$t('message.needProjectName')" maxlength="256" @blur="getList(form.projectName,'projectName')" />
                </el-form-item>
              </el-col>
              <!-- <el-col :span="5">
                <el-form-item :label="$t('page.prmList.projectName')" label-width="100px" class="positionAdjustment" />
                <el-input v-model="form.projectName" :placeholder="$t('message.needProjectName')" />
              </el-col> -->
              <el-col :span="6">
                <el-form-item :label="$t('page.prmNew.country')" prop="areaCode">
                  <el-select
                    ref="areaCode"
                    v-model="form.areaCode"
                    :placeholder="$t('message.select')"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in allCountries"
                      :key="item.areaCode"
                      :label="item.areaName"
                      :value="item.areaCode"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="8" v-if="!isChannelRole">
                <el-form-item :label="$t('page.prmList.country')">
                  <el-select style="width: 100%" v-model="form.nation" clearable filterable
                             :placeholder="$t('message.select')"
                  >
                    <el-option v-for="item in allCountries" :value="item.areaCode" :key="item.areaCode"
                               :label="item.areaName"
                    />
                  </el-select>
                </el-form-item>
              </el-col> -->
              <el-col :span="6">
                <el-form-item :label="$t('page.prmNew.finalCompanyName')" prop="finalCompanyName">
                  <el-input ref="finalCompanyName" v-model="form.finalUserName" :placeholder="$t('page.prmNew.finalCompanyName')" maxlength="256" @blur="getList(form.finalUserName,'finalUserName')" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('page.prmNew.finalCompanyAddress')" prop="finalCompanyAddress">
                  <el-input ref="finalCompanyAddress" v-model="form.finalCompanyAddress" :placeholder="$t('page.prmNew.finalCompanyAddress')" maxlength="256" @blur="getList(form.finalCompanyAddress,'finalCompanyAddress')" />
                </el-form-item>
              </el-col>
              <!-- <el-col :span="8">
                <el-form-item :label="$t('page.prmNew.finalCompanyName')" prop="finalUserName" label-width="210px">
                  <el-input v-model="form.finalUserName" :placeholder="$t('message.enterFinalUserName')" @keydown.native.13="search" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('page.prmNew.finalCompanyAddress')" prop="finalCompanyAddress" label-width="210px">
                  <el-input v-model="form.finalCompanyAddress" :placeholder="$t('message.enterFinalCompanyAddress')" @keydown.native.13="search" />
                </el-form-item>
              </el-col> -->
            </el-row>
            <el-row :gutter="20">
              <el-col :span="20" style="text-align: right; width:100%;">
                <el-button v-if="!btnSet.includes('btn_prm_search')" type="primary" class="submit" @click="clickSearchBtn" size="medium" plain>{{ $t("common.search") }}</el-button>
                <el-button v-if="!btnSet.includes('btn_prm_search')" class="cancle" size="medium" plain @click="reset">{{ $t("common.reset") }}</el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="table">
          <!-- <el-table :data="tabledata" border style="width: 100%; font-size: 14px" :row-class-name="tableRowClassName"></el-table> -->
          <el-table :data="tabledata" border style="width: 100%;font-size: 14px">
            <div v-if="istrue">
              <el-table-column prop="ruijieSaleEmail" align="center" :label="$t('page.ProjectSearch.email')" :render-header="fullHeader" show-overflow-tooltip />
              <el-table-column prop="result" align="center" :label="$t('page.ProjectSearch.result')" :render-header="fullHeader" show-overflow-tooltip />
              <el-table-column prop="areaName" align="center" :label="$t('page.ProjectSearch.country')" :render-header="fullHeader" show-overflow-tooltip />
              <el-table-column prop="ruijieSaleName" align="center" :label="$t('page.ProjectSearch.sales')" :render-header="fullHeader" show-overflow-tooltip />
            </div>
            <!--            <el-table-column prop="projectName" align="center" :label="$t('page.prmList.projectName')"-->
            <!--                             :render-header="fullHeader" show-overflow-tooltip-->
            <!--            />-->
            <!--            <el-table-column prop="finalCompanyName" align="center" :label="$t('page.prmNew.finalCompanyName')"-->
            <!--                             :render-header="fullHeader" show-overflow-tooltip-->
            <!--            />-->
            <!--            <el-table-column prop="finalCompanyAddress" align="center" :label="$t('page.prmNew.finalCompanyAddress')"-->
            <!--                             :render-header="fullHeader" show-overflow-tooltip-->
            <!--            />-->
            <el-table-column prop="ruijieSaleName" align="center" :label="$t('message.queryResult')" v-if="!istrue">
              <template slot-scope="scope">
                <!--                <el-button type="text" v-if="scope.row.canView===true" size="medium" @click="goviewpage(scope.row)">-->
                <!--                  {{ $t("common.view") }}-->
                <!--                </el-button>-->
                The project has been registered, please contact Ruijie sales {{ scope.row.ruijieSaleName }}
              </template>
            </el-table-column>
          </el-table>
          <div class="paging" style="text-align: right;margin-top: 20px">
            <el-pagination background
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="page.currentPage"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="page.pagesize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="page.total"
            />
          </div>
        </div>
      </template>
    </main-content>
  </div>
</template>

<script>
import API from '../../API';
import mainHead from '../component/mainHead';
import mainContent from '../component/mainContent';
import { merge } from '../../libs/util';
import store from '../../store';
export default {
  name: 'ProjectSearch',
  data () {
    return {
      allCountries: [],
      tabledata: [],
      pageloading: false,
      istrue: false,
      page: {
        currentPage: 1,
        pagesize: 20,
        total: 0
      },
      form: {
        projectName: '',
        finalUserName: '',
        finalCompanyAddress: '',
        registrationNo: '',
        areaCode: ''
      },
      btnSet: []
    };
  },
  components: {
    mainHead,
    mainContent
  },
  methods: {
    getList (value, values) {
      this.form[values] = value.trim();
    },
    init () {
      this.getCountries();
    },
    getCountries () {
      API.getAllCountries(this.$i18n.locale).then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.allCountries = json.data;
        }
      }).catch(e => {
        console.log(e);
      });
    },
    clickSearchBtn () {
      this.page.currentPage = 1;
      this.page.total = 0;
      this.search();
    },
    search () {
      this.tabledata = [];
      // this.page.total = 0;
      this.pageloading = true;
      let params = {
        pageNum: this.page.currentPage,
        pageSize: this.page.pagesize,
        language: this.$i18n.locale,
        areaCode: this.form.areaCode,
        registrationNo: this.form.registrationNo.trim(),
        projectNameEq: this.form.projectName.trim(),
        finalUserNameEq: this.form.finalUserName.trim(),
        finalCompanyAddressEq: this.form.finalCompanyAddress.trim()
      };
      let isSend = (params.projectNameEq.length > 1 || params.finalUserNameEq.length > 1 || params.finalCompanyAddressEq.length > 1 || params.registrationNo.length > 0);
      if (isSend) {
        API.queryProjectNoRestriction(params).then((res) => {
          this.pageloading = false;
          let json = res.data;
          if (json.status === '200') {
            if (json.data == null) {
              this.istrue = false;
            } else {
              this.tabledata = json.data.list;
              this.page.total = json.data.total;
              this.istrue = true;
            }
          }
        }).catch((ex) => {
          this.pageloading = false;
        });
      } else {
        // eslint-disable-next-line no-undef
        this.$message.error(this.$t('message.prompt'));
        this.pageloading = false;
      }
    },
    handleSizeChange (val) {
      this.page.pagesize = val;
      this.search();
    },
    handleCurrentChange (val) {
      this.page.currentPage = val;
      this.search();
    },
    fullHeader (h, { column }) {
      if (column.label) {
        return (h('el-tooltip', {
          attrs: {
            class: 'item',
            effect: 'dark',
            content: column.label,
            placement: 'bottom'
          }
        }, [ h('span', [column.label]) ]));
      }
    },
    goviewpage (row) {
      let query = merge(this.$route.query, {
        objectId: row.id
      });
      this.$router.push({
        name: 'prmDtl',
        query: query
      });
    },
    reset () {
      this.form = {
        projectName: '',
        finalUserName: '',
        finalCompanyAddress: '',
        registrationNo: '',
        areaCode: ''
      };
      this.page = {
        currentPage: 1,
        pagesize: 20,
        total: 0
      };
      this.search();
    }
  },
  mounted () {
    this.btnSet = store.state.UserBtnPermissionsData || [];
    this.init();
  }
};
</script>

<style lang="scss">
.prm-list{
  .form{
    .el-form-item__label{
      text-align: left;
    }
  }
  .table{
    margin-top: 20px;
  }
  .paging{
    margin-top: 20px;
    float: right;
  }
  .clear{
    clear: both;
  }
  .el-select{
    width: 100%;
  }
  .clause-a {
    margin-left: 20px;
    margin-right: 20px;
    color: #8b8b8b;
    text-decoration: underline
  }
}
</style>
